import basic from '../basic/ja'
export default {
    ...basic,
    ...{
        meta : {
            title : "無料の AI 画像ジェネレーター: テキストを画像に変換、オンラインで無料で顔を交換",
            keywords : "フェイススワップ、ディープフェイク、AI画像ジェネレーター、ビデオフェイススワップ、",
            description : "テキストプロンプトを使用して AI 生成画像やアートを作成し、高品質の AI 写真とビデオのフェイススワップをオンラインで作成し、Beauty AI 画像ジェネレーターを使用して思いつく限りの画像を作成します。",
        },        
        textimghomeindex : {
            titlebefore : 'AIアート',
            titleafter : "あなたのアイデアからインスピレーションを得たジェネレータ",
            subtitle : "数秒でテキストから素晴らしい画像を作成します。あなたのインスピレーションを現実にします。",
            buttontext : '今すぐ無料トライアル',
        },
        faceswaphomeindex : {
            titlebefore : '写真とビデオ',
            titleafter : '顔の交換',
            subtitle : 'AI がビデオや写真の顔を交換できるかどうか疑問に思っていませんか? 今すぐ試してみれば、クリックするだけで 1 分以内に素晴らしい顔の交換結果が得られます。',
            buttontext : '今すぐ顔を入れ替える',
        },
        showcasehomeindex : {
            title : 'AI生成画像',
            buttontext : '今すぐ無料トライアル',
            hovertitle : 'このプロンプトを試してください',
        },
        introducehomeindex : {
            item1title : 'AIアート画像をカスタマイズする',
            item1subtitle : "Beauty AI は、さまざまな芸術作品のアニメーションを作成するために、さまざまな画像を生成します。アニメのインスピレーション、急速な説明、画像の確認を決定します。アニメのキャラクターをテーマにした素晴らしい作品を見つけてください!",
            item1buttontext : '今すぐ無料トライアル',
            item2title : 'インスピレーションで本当のソウルメイトを生み出す',
            item2subtitle : '使いやすい AI 画像ジェネレーターとして、私たちはあなたの夢を叶えるために全力を尽くします。あなたの夢の女の子を簡単な言葉で表現すれば、数秒でアートを生成します。',
            item2buttontext : '今すぐ無料トライアル',
        },        
    },
}